webpackJsonp([12],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _module$exports;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

module.exports = (_module$exports = {
    ok: '確定',
    wky: '玩客雲',
    cancel: '取消',
    close: '關閉',
    yuan: '元',

    rule: 'Rule',
    note: 'Note',
    submit: 'Submit',
    qq: 'QQ number',
    phone: 'Cell phone number',
    delete: 'Delete',
    refresh: 'Refresh',
    netblock: 'Network is busy. Try again later.',
    view: 'View',
    more: 'More',
    less: 'Less',
    loadm: 'Load more',
    history: 'History',
    rtn: 'return',
    toofreq: 'Operation Too Frequent',
    isee: 'I see'
}, _defineProperty(_module$exports, 'cancel', 'Cancel'), _defineProperty(_module$exports, 'confirm', 'Confirm'), _defineProperty(_module$exports, 'onething_cloud', 'OneThing Cloud'), _defineProperty(_module$exports, 'open', 'Open'), _defineProperty(_module$exports, 'reload', 'Reload'), _defineProperty(_module$exports, 'lang', 'en'), _defineProperty(_module$exports, 'prompt', 'prompt'), _module$exports);

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    ok: '确定',
    wky: '玩客云',
    cancel: '取消',
    close: '关闭',
    yuan: '元',

    rule: '规则',
    note: '说明',
    submit: '提交',
    qq: 'QQ号',
    delete: '删除',
    refresh: '刷新',
    view: '查看',
    more: '展开',
    less: '收起',
    loadm: '加载更多',
    history: '历史记录',
    phone: '手机号',
    rtn: '返回',
    toofreq: '操作太频繁了',
    isee: '知道了',

    confirm: '确认',
    onething_cloud: '玩客云',
    open: '打开',
    reload: '重新加载',
    lang: 'zh',
    prompt: '提示'
};

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _Lang = __webpack_require__(5);

var _Lang2 = _interopRequireDefault(_Lang);

var _cn = __webpack_require__(14);

var _cn2 = _interopRequireDefault(_cn);

var _hk = __webpack_require__(15);

var _hk2 = _interopRequireDefault(_hk);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var langIns = new _Lang2.default({ cn: _cn2.default, hk: _hk2.default });
module.exports = function lang(key, params) {
	return langIns.getText(key, params);
};

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    ok: '确定',
    close: '关闭',
    please: '请在',
    hour: '小时',
    minutes: '分钟',
    pay_countdown: '内完成支付，剩余支付时间',
    order_cancel: '秒内完成支付，否则订单取消！',
    pay_wechat: '微信支付',
    min: '分',
    overtime_refresh: '秒内完成支付，超时二维码将过期，请刷新页面重新获取。',
    color_black: '曜石黑',
    color_orange: '爱马仕橙',
    color_blue: '科技蓝'
};

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    ok: '確定',
    close: '關閉',
    please: '请在',
    hour: '小時',
    minutes: '分钟',
    pay_countdown: '之內完成支付，剩餘支付時間',
    order_cancel: '秒內完成支付，否則訂單取消！',
    pay_wechat: '微信支付',
    min: '分',
    overtime_refresh: '秒內完成支付，逾時二維碼將逾期，請重新整理頁面重新獲取。',
    color_black: '曜石黑',
    color_orange: '愛馬仕橙',
    color_blue: '科技藍'
};

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.commonApi = exports.ONECLOUD_API_HOST = exports.ZQB_HOST = exports.GRAB_URL = exports.API_HOST = undefined;

var _utils = __webpack_require__(1);

var protocal = (0, _utils.getProtocol)();

var API_HOST = exports.API_HOST = protocal + 'wk-cgi.content.xunlei.com'; // 只有grabcode页面在用
var GRAB_URL = exports.GRAB_URL = API_HOST + '/wanke/?m=vceu0c9'; // 只有grabcode页面在用
var ZQB_HOST = exports.ZQB_HOST = 'http://zqb.red.xunlei.com'; // 只有exchange页面在用

var lang = (0, _utils.getLang)();
var apiSuffix = lang === 'cn' ? '' : '-' + lang;
var ONECLOUD_API_HOST = exports.ONECLOUD_API_HOST = protocal + 'api' + apiSuffix + '-content.onethingcloud.com/' + window.LANG;

var commonApi = exports.commonApi = {
    checklogin: ONECLOUD_API_HOST + '/user/checklogin',
    freshImgCode: ONECLOUD_API_HOST + '/captcha/refresh',
    // getconfig: `${ONECLOUD_API_HOST}/opensale/getconfig`,
    // commit: `${ONECLOUD_API_HOST}/opensale/commit`,
    usercouponlist: ONECLOUD_API_HOST + '/coupon/userCouponList',
    uploadImage: ONECLOUD_API_HOST + '/upload/imagecontent'
};

/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(8);

var _PSaleBook = __webpack_require__(265);

var _PSaleBook2 = _interopRequireDefault(_PSaleBook);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Demo = function (_Component) {
	_inherits(Demo, _Component);

	function Demo(props) {
		_classCallCheck(this, Demo);

		return _possibleConstructorReturn(this, (Demo.__proto__ || Object.getPrototypeOf(Demo)).call(this, props));
	}

	_createClass(Demo, [{
		key: 'render',
		value: function render() {
			return _react2.default.createElement(_PSaleBook2.default, null);
		}
	}]);

	return Demo;
}(_react.Component);

(0, _reactDom.render)(_react2.default.createElement(Demo, null), document.getElementById('content'));

/***/ }),

/***/ 265:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(1);

var _consts = __webpack_require__(2);

var _SaleComponents = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ACT_NOT_BEGIN = 0;
var ACT_ING = 1;
var ACT_END = 2;

var PSaleBook = function (_React$Component) {
    _inherits(PSaleBook, _React$Component);

    function PSaleBook(props) {
        _classCallCheck(this, PSaleBook);

        var _this = _possibleConstructorReturn(this, (PSaleBook.__proto__ || Object.getPrototypeOf(PSaleBook)).call(this, props));

        _this.state = {
            status: ACT_ING,
            lock: false
        };
        return _this;
    }

    _createClass(PSaleBook, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.loadConfig();
        }
    }, {
        key: 'loadConfig',
        value: function loadConfig() {
            var _this2 = this;

            $.ajax({
                type: "post",
                url: _consts.ONECLOUD_API_HOST + '/presale/getconfig?t=' + Date.now(),
                dataType: "json",
                crossDomain: true,
                xhrFields: { withCredentials: true },
                cache: false,
                //ifModified: true,
                success: function success(res) {
                    if (res.iRet === 0) {
                        _this2.setState({
                            status: res.data.status
                        });
                    }
                }
            });
        }
    }, {
        key: 'isActIng',
        value: function isActIng() {
            var status = this.state.status;
            return status === ACT_ING ? true : false;
        }
    }, {
        key: 'checkLogin',
        value: function checkLogin() {
            var depositUrl = (0, _utils.createUrl)('html/purchase', { type: 'deposit' });
            (0, _utils.stat)('join', 'presale');
            $.ajax({
                type: "post",
                url: _consts.ONECLOUD_API_HOST + '/user/checklogin',
                dataType: "json",
                crossDomain: true,
                xhrFields: { withCredentials: true },
                cache: false,
                ifModified: true,
                success: function success(res) {
                    var code = +res.iRet;
                    var url = void 0;
                    if (code === 0) {
                        location.href = depositUrl;
                    } else {
                        location.href = (0, _utils.createUrl)('html/login') + '?jumpurl=' + encodeURIComponent(depositUrl);
                    }
                },
                error: function error() {
                    location.href = depositUrl;
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var status = this.state.status;
            var btnCls = {
                '1': 'btn-activity btn-a-ban',
                '2': 'btn-activity',
                'gray': 'btn-a-disable'
            };
            var btn1 = null,
                btn2 = null,
                btnTip = null;

            if (status === ACT_ING) {
                btn1 = _react2.default.createElement(Btn, { className: btnCls['1'], onClick: function onClick() {
                        return _this3.checkLogin();
                    } });
                btn2 = _react2.default.createElement(Btn, { className: btnCls['2'], onClick: function onClick() {
                        return _this3.checkLogin();
                    } });
            } else {
                btn1 = _react2.default.createElement(Btn, { className: btnCls['1'] + ' ' + btnCls.gray, isActIng: false });
                btn2 = _react2.default.createElement(Btn, { className: btnCls['2'] + ' ' + btnCls.gray, isActIng: false });
                btnTip = _react2.default.createElement(
                    'p',
                    { className: 'a-ban-txt' },
                    '\u9884\u552E\u6D3B\u52A8\u5DF2\u7ED3\u675F'
                );
            }

            return _react2.default.createElement(
                'div',
                null,
                btn1,
                btnTip,
                _react2.default.createElement(
                    'div',
                    { className: 'a-unit a-unit-ban' },
                    _react2.default.createElement(
                        'ul',
                        { className: 'a-infolist' },
                        _react2.default.createElement(
                            'li',
                            { className: 'a-infolist-1' },
                            _react2.default.createElement('img', { src: '//static.onethingcloud.com/images/presell/left_pic.png', srcSet: '//static.onethingcloud.com/images/presell/left_pic.png, //wk-sic.content.xunlei.com/images/presell/left_pic_m.png 750w', alt: '' }),
                            _react2.default.createElement(
                                'div',
                                { className: 'a-infolist-txt' },
                                _react2.default.createElement(
                                    'h3',
                                    null,
                                    '\u63D0\u524D\u9884\u552E \xA5399'
                                ),
                                _react2.default.createElement(
                                    'p',
                                    null,
                                    '\u4E0D\u9884\u7EA6\u3001\u4E0D\u62A2\u8D2D'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            { className: 'a-infolist-2' },
                            _react2.default.createElement('img', { src: '//static.onethingcloud.com/images/presell/right_pic1.png', srcSet: '//static.onethingcloud.com/images/presell/right_pic1.png, //wk-sic.content.xunlei.com/images/presell/right_pic1_m.png 750w', alt: '' }),
                            _react2.default.createElement(
                                'div',
                                { className: 'a-infolist-txt' },
                                _react2.default.createElement(
                                    'h3',
                                    null,
                                    '\u6BCF\u4F4D\u73A9\u5BA2\u9650\u8D2D1\u53F0'
                                ),
                                _react2.default.createElement(
                                    'p',
                                    null,
                                    '\u8BA9\u6BCF\u4F4D\u73A9\u5BA2\u90FD\u80FD\u53C2\u4E0E\u4E2D\u56FD\u533A\u5757\u94FE\u5171\u4EAB\u8BA1\u7B97\u5EFA\u8BBE'
                                ),
                                _react2.default.createElement(
                                    'em',
                                    null,
                                    '\uFF08\u5DF2\u5728\u5B98\u7F51\u6210\u529F\u8D2D\u4E70\u7684\u7528\u6237\u65E0\u6CD5\u53C2\u4E0E\u672C\u6B21\u9884\u552E\u6D3B\u52A8\uFF09'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            { className: 'a-infolist-3' },
                            _react2.default.createElement('img', { src: '//static.onethingcloud.com/images/presell/right_pic2.png', srcSet: '//static.onethingcloud.com/images/presell/right_pic2.png, //wk-sic.content.xunlei.com/images/presell/right_pic2_m.png 750w', alt: '' }),
                            _react2.default.createElement(
                                'div',
                                { className: 'a-infolist-txt' },
                                _react2.default.createElement(
                                    'h3',
                                    null,
                                    '\u5148\u9009\u6536\u8D27\u65F6\u95F4\u518D\u4ED8\u6B3E'
                                ),
                                _react2.default.createElement(
                                    'p',
                                    null,
                                    '\u65E9\u4E0B\u5355\u3001\u65E9\u6536\u8D27\uFF0C\u6700\u65E91-2\u5468\u53D1\u8D27'
                                )
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'a-unit a-unit-rule' },
                    _react2.default.createElement(
                        'h3',
                        null,
                        '\u9884\u552E\u6D3B\u52A8\u89C4\u5219'
                    ),
                    _react2.default.createElement(
                        'ul',
                        { className: 'a-rule-list' },
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'h4',
                                null,
                                '\u9884\u552E\u6D3B\u52A8\u671F\u95F4'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                '12\u670813\u65E5-12\u670819\u65E5\uFF1B'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'h4',
                                null,
                                '\u9884\u552E\u5F00\u653E\u65F6\u95F4'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                '12\u670813\u65E5-19\u65E5 \u6BCF\u592910:00-18:00\uFF1B'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'h4',
                                null,
                                '\u9884\u552E\u5546\u54C1'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                '\u73A9\u5BA2\u4E91\uFF0C\u989C\u8272\u4E3A\u79D1\u6280\u84DD\u3001\u66DC\u77F3\u9ED1\u3001\u7231\u9A6C\u4ED5\u6A59\uFF1B'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'h4',
                                null,
                                '\u9884\u552E\u4EF7\u683C'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                '399\u5143\u5168\u6B3E\u9884\u552E\uFF1B'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'h4',
                                null,
                                '\u9884\u552E'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                '\u662F\u6307\u60A8\u65E0\u9700\u9884\u7EA6\u73A9\u5BA2\u4E91\uFF0C\u9009\u5B9A\u53D1\u8D27\u65F6\u95F4\u540E\u63D0\u524D\u5168\u6B3E\u652F\u4ED8\uFF0C\u4EE5\u60A8\u652F\u4ED8\u6210\u529F\u7CFB\u7EDF\u544A\u77E5\u53D1\u8D27\u65F6\u95F4\u4E3A\u51C6\uFF0C\u6211\u4EEC\u5C06\u6309\u627F\u8BFA\u7684\u65F6\u95F4\u9646\u7EED\u4E3A\u60A8\u5B89\u6392\u53D1\u8D27\uFF1B'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'h4',
                                null,
                                '\u9650\u8D2D\u6570\u91CF'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                _react2.default.createElement(
                                    'em',
                                    null,
                                    '\u4E3A\u5145\u5206\u4FDD\u969C\u7528\u6237\u6743\u76CA\uFF0C\u6BCF\u4E2A\u7528\u6237\u4EC5\u9650\u8D2D\u4E701\u53F0\u73A9\u5BA2\u4E91\uFF0C\u91CD\u590D\u8D2D\u4E70\u65E0\u6548\uFF0C\u5DF2\u7ECF\u6210\u529F\u5728\u73A9\u5BA2\u4E91\u5B98\u7F51\u8D2D\u4E70\u8FC7\u73A9\u5BA2\u4E91\u7684\u7528\u6237\u5C06\u65E0\u6CD5\u53C2\u4E0E\u672C\u6B21\u9884\u552E\u6D3B\u52A8\uFF1B'
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'h4',
                                null,
                                '\u53D1\u8D27\u65F6\u95F4'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                _react2.default.createElement(
                                    'em',
                                    null,
                                    '\u9884\u552E\u5546\u54C1\u7684\u53D1\u8D27\u65F6\u95F4\uFF0C\u5728\u60A8\u9009\u5B9A\u53D1\u8D27\u65F6\u95F4\u6863\u5185\u6309\u4ED8\u6B3E\u7684\u5148\u540E\u987A\u5E8F\u9646\u7EED\u5B89\u6392\u53D1\u51FA\uFF0C\u7F51\u5FC3\u79D1\u6280\u4FDD\u7559\u63D0\u524D\u53D1\u8D27\u7684\u6743\u5229\uFF0C'
                                ),
                                '\u4E3A\u4E86\u4FDD\u8BC1\u826F\u597D\u7684\u7528\u6237\u4F53\u9A8C\uFF0C\u6211\u4EEC\u4F1A\u5728\u6BCF\u6708\u8BBE\u7F6E\u53EF\u53D1\u8D27\u7684\u65F6\u95F4\u6863\u4F4D\u4F9B\u7528\u6237\u9009\u62E9\uFF1B'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'h4',
                                null,
                                '\u63D0\u4EA4\u8BA2\u5355'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                '\u8BF7\u6B63\u786E\u586B\u5199\u6536\u8D27\u4FE1\u606F\uFF0C\u9009\u53D6\u914D\u9001\u65B9\u5F0F\u5E76\u786E\u8BA4\u6240\u9009\u5546\u54C1\u989C\u8272\u3001\u4EF7\u683C\u4FE1\u606F\uFF0C\u8BF7\u5C3D\u5FEB\u63D0\u4EA4\u8BA2\u5355\uFF0C\u8BA2\u5355\u4E00\u65E6\u63D0\u4EA4\u5C06\u4E0D\u53EF\u53D6\u6D88\uFF1B'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'h4',
                                null,
                                '\u652F\u4ED8\u65F6\u6548'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                _react2.default.createElement(
                                    'em',
                                    null,
                                    '\u8BF7\u7559\u610F\u60A8\u7684\u8BA2\u5355\u652F\u4ED8\u65F6\u6548\uFF0C\u8BA2\u5355\u751F\u6210\u540E\u5373\u8FDB\u516515\u5206\u949F\u652F\u4ED8\u5012\u8BA1\u65F6\uFF0C'
                                ),
                                '\u6CA1\u6709\u5728\u652F\u4ED8\u65F6\u6548\u5185\u6210\u529F\u652F\u4ED8\u7684\u8BA2\u5355\uFF0C\u7CFB\u7EDF\u5C06\u89C6\u4E3A\u60A8\u81EA\u52A8\u653E\u5F03\u5E76\u53D6\u6D88\u8BA2\u5355\uFF0C\u60A8\u6240\u5360\u7684\u53D1\u8D27\u65F6\u95F4\u540D\u989D\u4E5F\u5C06\u88AB\u91CD\u65B0\u91CA\u653E\uFF0C\u5DF2\u652F\u4ED8\u6210\u529F\u7684\u8BA2\u5355\u89C6\u4E3A\u672C\u6B21\u9884\u552E\u4E0B\u5355\u6210\u529F\uFF1B'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'h4',
                                null,
                                '\u6709\u5173\u652F\u4ED8'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                '\u6BCF\u4F4D\u7528\u6237\u53EF\u4EE5\u4E0B\u53552\u6B21\uFF0C\u4EC5\u53EF\u6210\u529F\u8D2D\u4E701\u6B21\u3002\u60A8\u5728\u8BA2\u5355\u751F\u6210\u540E\u5B9E\u9645\u4ED8\u6B3E\u524D\u8D85\u8FC72\u6B21\u8D85\u65F6\u672A\u652F\u4ED8\u8BA2\u5355\uFF0C\u5C06\u5931\u53BB\u7EE7\u7EED\u53C2\u4E0E\u672C\u6B21\u9884\u552E\u6D3B\u52A8\u7684\u8D44\u683C\uFF0C\u7528\u6237\u5B8C\u6210\u652F\u4ED8\u7684\u65F6\u95F4\u4EE5\u7B2C\u4E09\u65B9\u652F\u4ED8\u6216\u94F6\u884C\u63D0\u4F9B\u7ED9\u7F51\u5FC3\u7684\u652F\u4ED8\u6D41\u6C34\u65F6\u95F4\u4E3A\u51C6\uFF1B'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'h4',
                                null,
                                '\u9884\u552E\u5546\u54C1\u652F\u4ED8\u4EF7\u683C'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                '\u4EE5\u60A8\u652F\u4ED8\u6210\u529F\u65F6\u7684\u4EF7\u683C\u4E3A\u51C6\uFF0C\u5982\u9884\u552E\u5546\u54C1\u53D1\u751F\u8C03\u4EF7\uFF0C\u5DF2\u652F\u4ED8\u8BA2\u5355\u5C06\u4E0D\u53D7\u5F71\u54CD\uFF1B'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'h4',
                                null,
                                '\u9884\u552E\u8BA2\u5355\u5FEB\u9012'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                '\u9884\u552E\u8BA2\u5355\u4E0D\u652F\u6301\u81EA\u63D0\uFF0C\u6211\u4EEC\u9ED8\u8BA4\u7533\u901A\u5FEB\u9012\uFF0C\u5982\u9009\u987A\u4E30\u5FEB\u9012\uFF0C\u9700\u989D\u5916\u652F\u4ED818\u5143\u5FEB\u9012\u8D39\u7528\uFF1B'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'h4',
                                null,
                                '\u6DD8\u5B9D\u4F17\u7B79\u4F18\u60E0\u5238'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                '\u672C\u6B21\u9884\u552E\u6D3B\u52A8\u652F\u6301\u6DD8\u5B9D\u4F17\u7B79\u671F\u95F4\u8D2D\u4E70\u7684\u4F18\u60E0\u5238\u62B5\u6263\uFF0C\u8BF7\u5728\u4F18\u60E0\u5238\u6709\u6548\u671F\u524D\u5B8C\u6210\u4F7F\u7528\uFF0C\u4F18\u60E0\u5238\u6BCF\u4E2A\u7528\u6237\u53EA\u80FD\u4F7F\u75281\u5F20\uFF0C\u4E0D\u53EF\u53E0\u52A0\uFF0C\u4E00\u7ECF\u4F7F\u7528\u7ACB\u5373\u4F5C\u5E9F\uFF0C\u5982\u4F7F\u7528\u4F18\u60E0\u5238\u540E\u7533\u8BF7\u53D6\u6D88\u8BA2\u5355\uFF0C\u9000\u6B3E\u65F6\u4EE5\u5B9E\u9645\u652F\u4ED8\u91D1\u989D\u4E3A\u51C6\uFF1B'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'h4',
                                null,
                                '\u9884\u552E\u8BA2\u5355\u9000\u6B3E'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                '\u9884\u552E\u8BA2\u5355\u5728\u9884\u552E\u6D3B\u52A8\u7ED3\u675F\u540E\u81F3\u53D1\u8D27\u65E5\u7684\u524D\u4E00\u5929\u4E2D\u534812:00\u4E4B\u524D\uFF0C\u7528\u6237\u53EF\u901A\u8FC7\u6211\u7684\u8BA2\u5355\u81EA\u52A8\u7533\u8BF7\u552E\u540E\u53D6\u6D88\u9884\u552E\u8BA2\u5355\uFF0C\u5BA2\u670D\u5728\u6536\u5230\u60A8\u7684\u7533\u8BF7\u540E\uFF0C\u5C06\u4E8E3-5\u4E2A\u5DE5\u4F5C\u65E5\u5185\u4E3A\u60A8\u529E\u7406\u9000\u6B3E\u64CD\u4F5C\uFF0C\u9884\u552E\u8BA2\u5355\u53D1\u8D27\u540E\uFF0C\u9000\u6362\u8D27\u6D41\u7A0B\u540C\u6B63\u5E38\u8BA2\u5355\u4E00\u81F4\uFF1B'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'h4',
                                null,
                                '\u8BA2\u5355\u5730\u5740\u4E0D\u53EF\u4FEE\u6539'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                '\u4E3A\u6253\u51FB\u9EC4\u725B\uFF0C\u6536\u8D27\u4FE1\u606F\u5C06\u4E0D\u53EF\u53D8\u66F4\uFF0C\u8BF7\u4ED4\u7EC6\u786E\u8BA4\u60A8\u7684\u6536\u8D27\u4FE1\u606F\uFF0C\u4ED8\u6B3E\u6210\u529F\u540E\u5C06\u4E0D\u53EF\u66F4\u6539\uFF1B'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'h4',
                                null,
                                '\u9632\u8303\u9EC4\u725B'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                '\u4E3A\u4FDD\u62A4\u5E7F\u5927\u7528\u6237\u7684\u6743\u76CA\uFF0C\u6253\u51FB\u9EC4\u725B\u9AD8\u4EF7\u5012\u5356\uFF0C\u7F51\u5FC3\u5C06\u4FDD\u7559\u53D6\u6D88\u6076\u610F\u8BA2\u5355\u5E76\u7ED9\u4E88\u9000\u6B3E\u7684\u6743\u5229\uFF0C\u4E00\u65E6\u53D1\u73B0\u7528\u6237\u5B58\u5728\u6076\u610F\u5237\u5355\u3001\u4E00\u4EBA\u591A\u5355\u3001\u8D85\u65F6\u652F\u4ED8\u7B49\u8FDD\u89C4\u884C\u4E3A\uFF0C\u7F51\u5FC3\u6709\u6743\u7ACB\u5373\u53D6\u6D88\u7528\u6237\u7684\u8BA2\u5355\u5E76\u7ED9\u4E88\u9000\u6B3E\uFF0C\u4E14\u8BE5\u7528\u6237\u5931\u53BB\u7EE7\u7EED\u53C2\u4E0E\u672C\u6B21\u9884\u552E\u6D3B\u52A8\u7684\u8D44\u683C\u3002\u7F51\u5FC3\u6709\u6743\u4F9D\u636E\u672C\u534F\u8BAE\u7EA6\u5B9A\u5185\u5BB9\u57FA\u4E8E\u72EC\u7ACB\u81EA\u4E3B\u5224\u65AD\u8BA4\u5B9A\u7528\u6237\u662F\u5426\u5B58\u5728\u6076\u610F\u5237\u5355\u3001\u4E00\u4EBA\u591A\u5355\u3001\u8D85\u65F6\u652F\u4ED8\u7B49\u8FDD\u89C4\u884C\u4E3A\uFF0C\u5982\u7528\u6237\u5BF9\u7F51\u5FC3\u53D6\u6D88\u8BA2\u5355\u5B58\u6709\u5F02\u8BAE\u7684\uFF0C\u5E94\u5F53\u81EA\u5176\u8BA2\u5355\u88AB\u53D6\u6D88\u8D7724\u5C0F\u65F6\u5185\u4E0E\u7F51\u5FC3\u8054\u7CFB\uFF0C\u8D85\u8FC724\u5C0F\u65F6\u7684\uFF0C\u89C6\u4E3A\u7528\u6237\u4E0D\u5B58\u6709\u4EFB\u4F55\u5F02\u8BAE\u3002'
                            )
                        ),
                        _react2.default.createElement(
                            'li',
                            null,
                            _react2.default.createElement(
                                'h4',
                                null,
                                '\u6E29\u99A8\u63D0\u793A'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                '1\u3001\u73A9\u5BA2\u4E91\u5B98\u65B9\u8D2D\u4E70\u6E20\u9053\uFF1A\u73A9\u5BA2\u4E91PC\u7248\u5B98\u7F51\u3001\u79FB\u52A8\u7248\u5B98\u7F51\uFF1B'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                '2\u3001\u4E3A\u786E\u4FDD\u60A8\u5728\u66F4\u65E9\u7684\u65F6\u95F4\u62FF\u5230\u5546\u54C1\uFF0C\u8BF7\u5728\u5F00\u552E\u524D\u6821\u51C6\u60A8\u7684\u7535\u8111\u6216\u624B\u673A\u65F6\u95F4\uFF1B'
                            ),
                            _react2.default.createElement(
                                'p',
                                null,
                                '3\u3001\u5982\u6709\u4EFB\u4F55\u7591\u95EE\u8BF7\u62E8\u6253400-109-8880\u8FD8\u53EF\u8BBF\u95EE\u670D\u52A1\u9875',
                                _react2.default.createElement(
                                    'a',
                                    { href: 'http://wpa.qq.com/msgrd?v=3&uin=212454816&site=qq&menu=yes', target: '_blank' },
                                    '\u8054\u7CFBQQ\u5728\u7EBF\u5BA2\u670D'
                                ),
                                '\uFF0C\u670D\u52A1\u65F6\u95F4 09:00-21:00\u3002'
                            )
                        )
                    ),
                    btn2
                )
            );
        }
    }]);

    return PSaleBook;
}(_react2.default.Component);

exports.default = PSaleBook;


var Btn = function Btn(_ref) {
    var isActIng = _ref.isActIng,
        className = _ref.className,
        onClick = _ref.onClick;
    return isActIng ? _react2.default.createElement(
        'a',
        { href: 'javascript:;', className: className, onClick: onClick },
        '\u53C2\u4E0E\u9884\u552E'
    ) : _react2.default.createElement(
        'a',
        { href: 'javascript:;', className: className },
        '\u53C2\u4E0E\u9884\u552E'
    );
};
Btn.defaultProps = {
    isActIng: true
};

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CountDown = exports.reg = exports.configParams = exports.pageLinks = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.closeTipPop = closeTipPop;
exports.TipPop = TipPop;
exports.TipLoadingPop = TipLoadingPop;
exports.getOneCloudDevice = getOneCloudDevice;
exports.jumpToLogin = jumpToLogin;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(1);

var _index = __webpack_require__(13);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var pageLinks = exports.pageLinks = {
    wxcode: (0, _utils.createUrl)('html/wxcode'),
    ywtcode: (0, _utils.createUrl)('html/ywtcode'),
    ucenter: (0, _utils.createUrl)('html/usercenter'),
    pay: (0, _utils.createUrl)('html/pay'),
    purchase: (0, _utils.createUrl)('html/purchase'),
    book: (0, _utils.createUrl)('html/book'),
    psalebook: (0, _utils.createUrl)('html/psalebook'),
    businesscenter: (0, _utils.createUrl)('html/businesscenter')
};

var configParams = exports.configParams = {
    orderType: {
        grab: 0,
        fcode: 1,
        presale: 2,
        tqcode: 3,
        opensale: 4,
        mini: 4,
        business: 5
    }
};

var reg = exports.reg = {
    phone: /^(13|14|15|16|17|18|19)[\d]{9}$/,
    phone_hk: /^\d{8}$/,
    recvAddress: /^([\u4E00-\u9FFF]|\d|[A-Z]|-|\s)+$/i,
    title: /^([\u4E00-\u9FFF]|\d|[A-Z]|-|\（|\）|\(|\)|\s){1,40}$/i, //发票抬头
    taxId: /^((\d|[A-Z]){15}|(\d|[A-Z]){18}|(\d|[A-Z]){20})$/i, //纳税人识别码
    email: /^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/,
    telephone: /^(((0\d{2,3})-)(\d{7,8})(-(\d{3,}))?|(13|14|15|16|17|18|19)[\d]{9})$/, // 电话 & 手机
    depositBank: /^[\u4E00-\u9FFF]{1,30}$/, // 开户银行
    bankAccount: /^\d{1,50}$/ //银行账号
};

function closeTipPop() {
    this.setState({
        pop: null
    });
    (0, _utils.removeClassFromHtmlElement)();
}

function TipPop(props) {
    var btn = props.btn ? props.btn : (0, _index2.default)('ok');
    var msg = props.msg;

    var dangerousInnerHTML = {
        __html: msg
    };
    return _react2.default.createElement(
        'div',
        { className: 'oc-pop' },
        _react2.default.createElement(
            'div',
            { className: 'oc-pop-wp' },
            _react2.default.createElement(
                'div',
                { className: 'oc-pop-textbox oc-tb' },
                _react2.default.createElement(
                    'div',
                    { className: 'oc-pop-text oc-tb-cell' },
                    msg.length <= 15 ? _react2.default.createElement(
                        'h3',
                        null,
                        msg
                    ) : _react2.default.createElement('div', { dangerouslySetInnerHTML: dangerousInnerHTML })
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'oc-pop-btnbox' },
                props.link ? _react2.default.createElement(
                    'a',
                    { href: props.link, className: 'btn-oc' },
                    btn
                ) : _react2.default.createElement(
                    'a',
                    { href: 'javascript:;', className: 'btn-oc', onClick: props.onClose },
                    btn
                )
            ),
            props.hideClose ? null : _react2.default.createElement(
                'a',
                { href: 'javascript:;', className: 'oc-pop-close', onClick: props.onClose },
                't(\'close\')'
            )
        )
    );
}

function TipLoadingPop(props) {
    return _react2.default.createElement(
        'div',
        { className: 'oc-pop' },
        _react2.default.createElement(
            'div',
            { className: 'oc-pop-wp' },
            _react2.default.createElement(
                'div',
                { className: 'oc-pop-textbox oc-tb' },
                _react2.default.createElement(
                    'div',
                    { className: 'oc-pop-text oc-tb-cell' },
                    props.msg.length <= 15 ? _react2.default.createElement(
                        'h3',
                        null,
                        props.msg
                    ) : _react2.default.createElement(
                        'div',
                        null,
                        props.msg
                    )
                )
            )
        )
    );
}

var CountDown = exports.CountDown = function (_Component) {
    _inherits(CountDown, _Component);

    function CountDown(props) {
        _classCallCheck(this, CountDown);

        var _this = _possibleConstructorReturn(this, (CountDown.__proto__ || Object.getPrototypeOf(CountDown)).call(this, props));

        _this.state = {
            day: 0,
            hour: 0,
            min: 0,
            secs: 0
        };
        _this.Timer = null;
        return _this;
    }

    _createClass(CountDown, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(props) {
            var _this2 = this;

            var seconds = props.seconds;


            if (seconds !== this.props.seconds) {

                this.setState({
                    day: ~~(seconds / 86400),
                    hour: ~~(seconds % 86400 / 3600),
                    min: ~~(seconds % 3600 / 60),
                    secs: seconds % 60
                }, function () {
                    clearInterval(_this2.Timer);
                    _this2.Tick();
                    _this2.Timer = setInterval(function () {
                        return _this2.Tick();
                    }, 1000);
                });
                return true;
            }
            return false;
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearInterval(this.Timer);
        }
    }, {
        key: 'Tick',
        value: function Tick() {
            var _state = this.state,
                day = _state.day,
                hour = _state.hour,
                min = _state.min,
                secs = _state.secs;

            day = +day;
            hour = +hour;
            min = +min;
            secs = +secs;
            if (day === 0 && hour === 0 && min === 0 && secs === 0) {
                clearInterval(this.Timer);
                this.setState({
                    day: '0',
                    hour: '00',
                    min: '00',
                    secs: '00'
                });
                this.props.callback();
                return;
            } else if (day > 0 && hour === 0 && min === 0 && secs === 0) {
                day -= 1;
                hour = 23;
                min = 59;
                secs = 59;
            } else if (hour > 0 && min === 0 && secs === 0) {
                hour -= 1;
                min = 59;
                secs = 59;
            } else if (min >= 0) {
                if (secs > 0) {
                    secs -= 1;
                } else if (secs === 0) {
                    min -= 1;
                    secs = 59;
                }
            }

            this.setState({ day: day, hour: hour, min: min, secs: secs });
        }
    }, {
        key: 'addZero',
        value: function addZero(num) {
            num = +num;
            return num - 10 >= 0 ? num : '0' + num;
        }
    }, {
        key: 'getTextDom',
        value: function getTextDom() {
            var _state2 = this.state,
                day = _state2.day,
                hour = _state2.hour,
                min = _state2.min,
                secs = _state2.secs;

            if (day > 0) {
                return _react2.default.createElement(
                    'h4',
                    null,
                    (0, _index2.default)('please'),
                    _react2.default.createElement(
                        'span',
                        null,
                        day
                    ),
                    '\u5929',
                    _react2.default.createElement(
                        'span',
                        null,
                        hour
                    ),
                    '\u5C0F\u65F6',
                    _react2.default.createElement(
                        'span',
                        null,
                        min
                    ),
                    (0, _index2.default)('minutes'),
                    _react2.default.createElement(
                        'span',
                        null,
                        secs
                    ),
                    (0, _index2.default)('order_cancel')
                );
            }
            if (hour > 0) {
                return _react2.default.createElement(
                    'h4',
                    null,
                    (0, _index2.default)('please'),
                    _react2.default.createElement(
                        'span',
                        null,
                        hour
                    ),
                    '\u5C0F\u65F6',
                    _react2.default.createElement(
                        'span',
                        null,
                        min
                    ),
                    (0, _index2.default)('minutes'),
                    _react2.default.createElement(
                        'span',
                        null,
                        secs
                    ),
                    (0, _index2.default)('order_cancel')
                );
            }
            return _react2.default.createElement(
                'h4',
                null,
                (0, _index2.default)('please'),
                _react2.default.createElement(
                    'span',
                    null,
                    min
                ),
                (0, _index2.default)('minutes'),
                _react2.default.createElement(
                    'span',
                    null,
                    secs
                ),
                (0, _index2.default)('order_cancel')
            );
        }
    }, {
        key: 'getClockDom',
        value: function getClockDom() {
            var _state3 = this.state,
                day = _state3.day,
                hour = _state3.hour,
                min = _state3.min,
                secs = _state3.secs;

            if (day > 0) {
                return _react2.default.createElement(
                    'strong',
                    null,
                    day + '\u5929' + this.addZero(hour) + (0, _index2.default)('hour') + this.addZero(min) + (0, _index2.default)('min') + this.addZero(secs) + '\u79D2'
                );
            }
            return _react2.default.createElement(
                'strong',
                null,
                this.addZero(hour) + ':' + this.addZero(min) + ':' + this.addZero(secs)
            );
        }
    }, {
        key: 'getPayDom',
        value: function getPayDom() {
            var canCancel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
            var _state4 = this.state,
                day = _state4.day,
                hour = _state4.hour,
                min = _state4.min;

            var minStr = this.addZero(min);
            var cancelTxt = canCancel ? ', 超时后将取消订单' : '';
            if (day > 0) return _react2.default.createElement(
                'h4',
                null,
                '\u8BF7\u5728 ',
                _react2.default.createElement(
                    'em',
                    { className: 'oc-col-blue' },
                    _react2.default.createElement(
                        'span',
                        null,
                        day
                    ),
                    '\u5929',
                    _react2.default.createElement(
                        'span',
                        null,
                        hour
                    ),
                    '\u5C0F\u65F6',
                    _react2.default.createElement(
                        'span',
                        null,
                        minStr
                    ),
                    '\u5206'
                ),
                ' \u5185\u5B8C\u6210\u652F\u4ED8',
                cancelTxt
            );
            if (hour > 0) return _react2.default.createElement(
                'h4',
                null,
                '\u8BF7\u5728 ',
                _react2.default.createElement(
                    'em',
                    { className: 'oc-col-blue' },
                    _react2.default.createElement(
                        'span',
                        null,
                        hour
                    ),
                    '\u5C0F\u65F6',
                    _react2.default.createElement(
                        'span',
                        null,
                        minStr
                    ),
                    '\u5206'
                ),
                ' \u5185\u5B8C\u6210\u652F\u4ED8',
                cancelTxt
            );
            return _react2.default.createElement(
                'h4',
                null,
                '\u8BF7\u5728 ',
                _react2.default.createElement(
                    'em',
                    { className: 'oc-col-blue' },
                    _react2.default.createElement(
                        'span',
                        null,
                        minStr
                    ),
                    '\u5206'
                ),
                ' \u5185\u5B8C\u6210\u652F\u4ED8',
                cancelTxt
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _state5 = this.state,
                min = _state5.min,
                secs = _state5.secs;
            var _props = this.props,
                orderTime = _props.orderTime,
                orderTimeUnit = _props.orderTimeUnit,
                format = _props.format,
                isYWT = _props.isYWT;

            var units = {
                'm': (0, _index2.default)('minutes'),
                'h': '小时',
                'd': '天'
            };

            var disp = {
                clock: _react2.default.createElement(
                    'p',
                    null,
                    (0, _index2.default)('please'),
                    _react2.default.createElement(
                        'strong',
                        null,
                        orderTime,
                        units[orderTimeUnit]
                    ),
                    (0, _index2.default)('pay_countdown'),
                    this.getClockDom()
                ),
                text: this.getTextDom(),
                // wxcode: <h2>{ isYWT && '一网通支付' }<em>{t('please')}{min}{t('min')}{secs}{t('overtime_refresh')}</em></h2>,
                wxcode: _react2.default.createElement(
                    'em',
                    null,
                    '\u652F\u4ED8\u5012\u8BA1\u65F6\uFF1A\u8BF7\u5728' + min + '\u5206' + secs + '\u79D2\u5185\u5B8C\u6210\u652F\u4ED8\uFF0C\u8D85\u65F6\u4E8C\u7EF4\u7801\u5C06\u8FC7\u671F\uFF0C\u8BF7\u5237\u65B0\u9875\u9762\u91CD\u65B0\u83B7\u53D6'
                ),
                pay: this.getPayDom(),
                mini: this.getPayDom(false)
            };

            return _react2.default.createElement(
                'div',
                null,
                disp[format]
            );
        }
    }]);

    return CountDown;
}(_react.Component);

CountDown.defaultProps = {
    callback: function callback() {},
    orderTime: 45,
    orderTimeUnit: 'm', // 分钟
    isYWT: false
};

function getOneCloudDevice(data) {
    if (data.black_num) return { img: '/images/purchase/oc_pro_1.jpg', color: (0, _index2.default)('color_black') };
    if (data.blue_num) return { img: '/images/purchase/oc_pro_3.jpg', color: (0, _index2.default)('color_blue') };
    if (data.orange_num) return { img: '/images/purchase/oc_pro_2.jpg', color: (0, _index2.default)('color_orange') };
    return { img: '', color: '' };
}

function jumpToLogin() {
    location.href = (0, _utils.createUrl)('html/login') + '?jumpurl=' + encodeURIComponent(location.href);
}

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _common = __webpack_require__(9);

var _common2 = _interopRequireDefault(_common);

var _utils = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var VALID_LANG = ['cn', 'hk'];

var Lang = function () {
    function Lang(langData) {
        _classCallCheck(this, Lang);

        this.data = langData;
        this.language = this._getLanguage();
        this.currData = this._getCurrData();
    }

    // cookie,lang属性判断语言
    // _getLanguage(){
    //     let browserLang = getCookie('lang') || 'cn'
    //     let lang = VALID_LANG.indexOf(browserLang) == -1 ? VALID_LANG[0] : browserLang
    //     console.log(lang)
    //     return lang
    // }

    //根据url来判断语言


    _createClass(Lang, [{
        key: '_getLanguage',
        value: function _getLanguage() {
            var browserLang = (0, _utils.getLang)(); //menu.js里定义的变量
            var lang = VALID_LANG.indexOf(browserLang) == -1 ? VALID_LANG[0] : browserLang;
            // console.log('18lang: '+lang);
            return lang;
        }
    }, {
        key: '_getCurrData',
        value: function _getCurrData() {
            var localLang = this.data[this.language] || {};
            var commonLang = _common2.default[this.language] || {};
            return _extends({}, commonLang, localLang);
        }
    }, {
        key: 'getText',
        value: function getText(key) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            var text = this.currData[key] || '';
            if (typeof text == 'string' || typeof text == 'number') {
                for (var i in params) {
                    text = text.replace(':' + i, params[i]);
                }
            }
            return text;
        }
    }]);

    return Lang;
}();

module.exports = Lang;

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _hk = __webpack_require__(10);

var _hk2 = _interopRequireDefault(_hk);

var _cn = __webpack_require__(11);

var _cn2 = _interopRequireDefault(_cn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
	hk: _hk2.default, cn: _cn2.default
};

/***/ })

},[264]);


// WEBPACK FOOTER //
// psalebook.dist.js